<template>
  <v-card width="100%" height="100%" flat>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>fas fa-users-cog</v-icon>
      Admin
    </v-toolbar>
    <v-card-text>
      <v-row align="start" justify="center">
        <v-card height="200px" width="200px" color="grey lighten-3" v-for="navItem in getAdminNav" :key="navItem.item" class="ma-5 pa-5" outlined ripple :to="navItem.link">
          <v-container fluid fill-height>
            <v-row align="center" class="text-center">
              <v-col align-items="center" class="subtitle-1">
                <v-icon>{{navItem.icon}}</v-icon>
                <br>
                {{navItem.item}}
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <!-- SOCIAL MEDIA CARD -->
        <!-- <v-card height="200px" width="200px" color="grey lighten-3" class="ma-5 pa-5" outlined ripple to="/Social">
          <v-container fluid fill-height>
            <v-row align="center" class="text-center">
              <v-col align-items="center" class="subtitle-1">
                <v-icon left>fab fa-facebook</v-icon>
                <v-icon>fab fa-twitter</v-icon>
                <v-icon right>fab fa-instagram</v-icon>
                <br>
                Post to Social Media
              </v-col>
            </v-row>
          </v-container>
        </v-card> -->
      </v-row>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-toolbar flat dense color="secondary" dark class="title">Non-Admin Links</v-toolbar>
        </v-col>
        <v-card height="200px" width="200px" v-for="navItem in getNav" :key="navItem.item" class="ma-5 pa-5" outlined ripple :to="navItem.link">
          <v-container fluid fill-height>
            <v-row align="center" class="text-center">
              <v-col align-items="center" class="subtitle-1">
                <v-icon>{{navItem.icon}}</v-icon>
                <br>
                {{navItem.item}}
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import mixins from '@/plugins/mixins.js'
export default {
  mixins: [mixins],
  computed: {
    getAdminNav(){
      return this.$store.getters.getAdminNav
    },
    getNav(){
      return this.$store.getters.getNav.filter(item => item.item != 'Home')
    }
  }
}
</script>
